import './NotBoughtProducts.scss'

import {Alert, Button, Image, message} from 'antd'
import {AppRoutes} from 'App'
import {getFormattedPrice} from 'helpers/Formatting'
import {useNavigate} from 'react-router-dom'

import {useSiparisDetayQuery} from '../../gql/GeneratedGraphqlTypes'
import {NotBoughtProductsItem} from './types'

interface Props {
    siparis: string
}

const NotBoughtProducts = ({siparis}: Props) => {
    const temp = parseInt(siparis)
    const navigate = useNavigate()
    const [messageApi] = message.useMessage()
    const {data, error} = useSiparisDetayQuery({
        variables: {siparis_id: temp},
    })
    if (error) {
        messageApi.error(`${error}`, 2)
    }
    if (!data) {
        return null
    }
    const sinifId = data?.siparisDetay.sinif_id
    const NotBoughtProductsItems: NotBoughtProductsItem[] = (data?.siparisDetay.satin_alinmayan_urunler || []).map(
        (urun, index) => {
            return {
                key: index.toString() || '',
                urun_ismi: urun?.urun_ismi || '',
                aciklama: '',
                adet: typeof urun?.urun_adet === 'number' ? urun.urun_adet : parseFloat(urun?.urun_adet || '0'),
                urun_birim_fiyat: `${getFormattedPrice(String(urun?.urun_birim_fiyat ?? '0'))} ₺`,
                ders_ismi: urun?.ders_ismi || '',
                images: (urun?.resimler?.filter(Boolean) as string[]) || [],
            }
        },
    )
    NotBoughtProductsItems.reverse()

    return (
        <>
            <div className="not-bought-products">
                <Alert
                    className="custom-alert"
                    description="Öğrencinizin sınıf listesinden satın almadığınız ürünler listelenmektedir."
                    type="success"
                />
                {sinifId && NotBoughtProductsItems.length > 0 && (
                    <div style={{marginTop: 12, marginBottom: 4}}>
                        <Button
                            type="primary"
                            onClick={() => navigate(`/${AppRoutes.classProducts}/${sinifId}/`)}
                        >
                            Sınıf Listesine Git
                        </Button>
                    </div>
                )}
                <br/>
                <div className="not-bought-table">
                    <div className="not-bought-header">
                        <span>Ürün Adı</span>
                        <span>Ders</span>
                        <span>Adet</span>
                        <span>KDV Dahil Birim Fiyat</span>
                    </div>

                    {NotBoughtProductsItems.map((urun) => (
                        <div key={urun.key} className="not-bought-row">
                            <div className="left-side">
                                <Image src={urun.images[0] ?? ''} alt={urun.urun_ismi} className="order-product-image" width={72} height={72} />
                                <div>
                                    <span className="product-name">{urun.urun_ismi}</span>
                                    {urun.aciklama && <span className="product-aciklama"><span className="aciklama-label">Açıklama:</span> {urun.aciklama}</span>}
                                </div>
                            </div>

                            <p>{urun.ders_ismi}</p>
                            <p className="quantity">{urun.adet}</p>
                            <p>{urun.urun_birim_fiyat}</p>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default NotBoughtProducts
